import React, { useMemo } from 'react';
import { Box, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SalovareSelectField from '../common/SalovareSelectField';
import { isConsentFormActive } from '../../constants/ConsentForms';
import { getConsentFormName } from './consentFormDisplay';

const NO_FORM = '';

/** Chooses the consent form a service asks customers to accept before its first booking. */
const ConsentFormSelectField = ({ id, value, consentForms, onChange, disabled = false, sx }) => {
  const { t, i18n } = useTranslation();

  const options = useMemo(() => (consentForms || [])
    .filter((form) => form.currentVersion && (isConsentFormActive(form) || form.id === value))
    .map((form) => ({
      id: form.id,
      label: isConsentFormActive(form)
        ? getConsentFormName(form.name, i18n.language, t)
        : t('consentForms.serviceField.archived', { name: getConsentFormName(form.name, i18n.language, t) }),
      selectable: isConsentFormActive(form),
    })), [consentForms, i18n.language, t, value]);

  const hasForms = options.some((option) => option.selectable);
  const selectedValue = options.some((option) => option.id === value) ? value : NO_FORM;

  return (
    <Box id={id} sx={{ minWidth: 0, ...sx }}>
      <SalovareSelectField
        label={t('consentForms.serviceField.label')}
        value={selectedValue}
        onChange={(event) => onChange(event.target.value || null)}
        disabled={disabled || (!hasForms && !value)}
        displayEmpty
        inputProps={{ id: `${id}-select`, 'aria-label': t('consentForms.serviceField.label') }}
      >
        <MenuItem value={NO_FORM}>{t('consentForms.serviceField.none')}</MenuItem>
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id} disabled={!option.selectable}>
            {option.label}
          </MenuItem>
        ))}
      </SalovareSelectField>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
        {hasForms ? t('consentForms.serviceField.help') : t('consentForms.serviceField.noForms')}
      </Typography>
    </Box>
  );
};

export default ConsentFormSelectField;
